<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <ds-confirmation-link-area>
      <a
        class="font-weight-semibold"
        dsContent
        [contentPath]="'billing.backToBillingAndPayments'"
        href="javascript:void(0);"
        (click)="returnToBillingandPayments()"
      >
      </a>
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>
